import script from "./Send.vue?vue&type=script&lang=ts&setup=true"
export * from "./Send.vue?vue&type=script&lang=ts&setup=true"

import "./Send.vue?vue&type=style&index=0&id=4119de0c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4119de0c"]])

export default __exports__